import { Button as DefaultButton } from 'components';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Button = styled(DefaultButton)`
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  margin-top: ${({ theme }) => theme.spacing.md};

  ${from.mobileXL`
    margin: 0 0 0 auto;
  `};
`;
